import { render, staticRenderFns } from "./credits.vue?vue&type=template&id=312810f4&scoped=true&"
import script from "./credits.vue?vue&type=script&lang=js&"
export * from "./credits.vue?vue&type=script&lang=js&"
import style0 from "./credits.vue?vue&type=style&index=0&id=312810f4&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312810f4",
  null
  
)

export default component.exports